import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var Kerning = /** @class */ (function (_super) {
    __extends(Kerning, _super);
    function Kerning() {
        var _this = _super.call(this) || this;
        console.warn('[Kerning] not implemented');
        return _this;
    }
    Kerning.forceNativeConstructor = true;
    Kerning.forceNativeMethods = true;
    // JS -> AS Bindings
    Kerning.ON = 'on';
    Kerning.OFF = 'off';
    Kerning.AUTO = 'auto';
    return Kerning;
}(ASObject));
export { Kerning };
